import Logger from '../utils/logger';
import { supabase } from '../components/auth/AuthProvider';

export async function getAccessToken(): Promise<string | null> {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      Logger.error('Error while getting session', error);
      return null;
    }
    const token = data.session?.access_token || null;
    if (!token) {
      Logger.warn('No access token found from Supabase session when calling getAccessToken()');
    }
    return token;
  } catch (error) {
    Logger.error('Error while getting session', error);
    return null;
  }
}
